export function formatDate(date: string) {
  return new Date(date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function getName(space: boolean) {
  return space ? "HotFo" : "HotFo";
}